import { GoogleOAuthProvider } from '@react-oauth/google';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AnalyticsTracker from './components/AnalyticsTracker';
import ProtectedRoute from './components/ProtectedRoute';
import AuthChoice from './pages/AuthChoice';
import ContactDetail from './pages/ContactDetail';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import KYCVerification from './pages/KYCVerification';
import { PrivacyPage, TermsPage } from './pages/LegalDocument';
import LimitSettings from './pages/LimitSettings';
import LinkRedirect from './pages/LinkRedirect';
import Login from './pages/Login';
import OnrampReturn from './pages/OnrampReturn';
import PaymentRequestDetail from './pages/PaymentRequestDetail';
import Success from './pages/Success';
import TransactionReview from './pages/TransactionReview';
import TransakCheckout from './pages/TransakCheckout';
import Welcome from './pages/Welcome';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  const routes = (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AnalyticsTracker />
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Protected Routes - Require Login */}
          <Route path="/" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/settings/limits" element={
            <ProtectedRoute>
              <LimitSettings />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={<Navigate to="/?tab=settings#profile" replace />} />
          <Route path="/contacts/:contactId" element={
            <ProtectedRoute>
              <ContactDetail />
            </ProtectedRoute>
          } />
          <Route path="/payment-requests/:requestId" element={
            <ProtectedRoute>
              <PaymentRequestDetail />
            </ProtectedRoute>
          } />
          <Route path="/kyc" element={
            <ProtectedRoute>
              <KYCVerification />
            </ProtectedRoute>
          } />
          
          {/* Public Routes - No Login Required */}
          <Route path="/login" element={<Login />} />
          <Route path="/howitworks" element={<HowItWorks />} />
          <Route path="/tos" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/link" element={<LinkRedirect />} />
          <Route path="/welcome/:requestId" element={<Welcome />} />
          <Route path="/auth/:requestId" element={<AuthChoice />} />
          <Route path="/review/:requestId" element={<TransactionReview />} />
          <Route path="/kyc/:requestId" element={<KYCVerification />} />
          <Route path="/onramp-checkout/:requestId" element={<TransakCheckout />} />
          <Route path="/transak-checkout/:requestId" element={<TransakCheckout />} />
          <Route path="/onramp-return" element={<OnrampReturn />} />
          <Route path="/meld/return" element={<OnrampReturn />} />
          <Route path="/success/:transactionId" element={<Success />} />
        </Routes>
      </div>
    </Router>
    </GoogleOAuthProvider>
  );
  return routes;
  // return <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{routes}</GoogleOAuthProvider>;
}

export default App;
